'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

exports.default = makeDecoratedComponent;

var _fields = require('./fields');

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function makeDecoratedComponent(decorators, BaseComponent) {
  var DecoratedComponent = function (_Component) {
    _inherits(DecoratedComponent, _Component);

    function DecoratedComponent(props) {
      _classCallCheck(this, DecoratedComponent);

      var _this = _possibleConstructorReturn(this, Object.getPrototypeOf(DecoratedComponent).call(this, props));

      _this.handleSetState = _this.handleSetState.bind(_this);
      _this.state = (0, _fields.toInitialState)(decorators, props, _this.handleSetState, _this.context);
      return _this;
    }

    _createClass(DecoratedComponent, [{
      key: 'componentWillUnmount',
      value: function componentWillUnmount() {
        (0, _fields.toUnmount)(decorators, this.props, this.state, this.context);
      }
    }, {
      key: 'handleSetState',
      value: function handleSetState(fieldName, value) {
        this.setState(_defineProperty({}, fieldName, value));
      }
    }, {
      key: 'render',
      value: function render() {
        return _react2.default.createElement(BaseComponent, (0, _fields.toProps)(decorators, this.props, this.state, this.handleSetState, this.context));
      }
    }]);

    return DecoratedComponent;
  }(_react.Component);

  DecoratedComponent.contextTypes = (0, _fields.toContextTypes)(decorators, BaseComponent);

  DecoratedComponent.displayName = (0, _fields.toDisplayName)(decorators, BaseComponent);

  DecoratedComponent.defaultProps = (0, _fields.toDefaultProps)(decorators, BaseComponent);

  DecoratedComponent.propTypes = (0, _fields.toPropTypes)(decorators, BaseComponent);

  return DecoratedComponent;
}


/*****************
 ** WEBPACK FOOTER
 ** ../~/react-decorate/lib/makeDecoratedComponent.js
 ** module id = 719
 ** module chunks = 0
 **/